/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_ORGANIZATION = gql`
query Query {
  getMyOrganization {
    _id
    sameAs
    telephone
    description
    name
    email
    creator
    address {
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
    }
    fullAddress
    logo
    createdAt
    updatedAt
    OrgType
    type
    walletAddress
    chainId
    isWalletRegistered
    supportedChainId
    country
    platform_fee
    brokerage
    paymentOptions {
      paymentEnabled
      KYCSubmitted
      provider
      account
    }
    supportedCurrencies
  }
}
`;

// query Query {
//   getMyOrganization {
//     _id
//     logo
//     name
//     description
//     fullAddress
//     phoneNo
//     website
//     email
//   }
// }
